import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import Request from '@/utils/fetch';
import { calculateHeaderParams } from '@gcloud-npm/node.build-process.build-environments';
import { FAMILY_API } from '@gcloud-npm/utils.enums.environment';
import {
  makeUpTelcoPathName,
  getAdabyronConstants,
  PROCESS_NAME,
} from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';

const PATH = "consumos/misconsumos/acumulado/";
const EVENT_NAME = "USAGES.GET_ACCUMULATED_USAGE";
const METHOD = "GET";

export const getAccumulatedUsage = ({
  data,
  context,
  idFront = "TC",
  version,
  build = false,
  onRedirect,
}) => {
  const { environment, userType } = context;
  const { telco: connectionData } = environment;
  const { endpoint: host } = connectionData;
  const { productIds, month } = data;

  const idRequest = getUUID(idFront);
  const headers2Use = calculateHeaderParams(build, FAMILY_API.TELCO, context);
  const { prefixToApply } = getAdabyronConstants(userType);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME.CLIENT,
  });

  let queryParams = [];
  queryParams.push({ param: 'productIds', value: Array.isArray(productIds) ? productIds.join() : productIds });
  queryParams.push({ param: 'month', value: month || 0 });

  let urlParamsToReplace = [];

  const URL_API = makeUpTelcoPathName({
    path: PATH,
    version,
    idRequest,
    host,
    prefixToApply,
    queryParams,
    urlParamsToReplace,
  });

  const request = new Request({
    method: METHOD,
    endpoint: URL_API,
    headers: {
      ...headers2Use,
    },
    sonda,
    onRedirect: onRedirect || sendToRelogin,
  });

  return request.makeRequest();
};

export default getAccumulatedUsage;
